import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-chat-body',
  templateUrl: './chat-body.component.html',
  styleUrls: ['./chat-body.component.scss']
})
export class ChatBodyComponent implements OnInit {

  @Input() uid: string;
  constructor() { }

  ngOnInit() {
  }

}
